module.exports = __webpack_public_path__ + "static/media/hand-lizard.1cd92955.svg";